/*******************************************************************************

  Project: FRAUEN
  Author:  WHAT.DIGITAL
  Date:    DECEMBER 2021

********************************************************************************/

(function ($) {
    "use strict";

    jQuery(document).ready(function ($) {
        $(".modal-trigger").click((e) => {
            let buttonControls = e.target.attributes['aria-controls'].value;
            $("#" + buttonControls).addClass("active-modal");
            $("body").addClass("overlay");

            e.preventDefault();
        });

        $(".close-modal").click((e) => {
            $('.active-modal').removeClass('active-modal');
            $("body").removeClass("overlay");

            e.preventDefault();
        });

        $(".search-trigger").click(function(){
					$(".header-search").toggleClass("act");
					// Somehow, the focus event is not working without a timeout
					window.setTimeout(function () { 
						document.getElementById('searchFormControl').focus(); 
					}, 220); 
				});

				$('.search-form-submit').on('click', function(e) {
					$(".header-search").toggleClass("act");
				});

				// Close search form
				$('.search-close').on('click', function(e) {
					e.preventDefault();
					$(".header-search").toggleClass("act");
					document.getElementById('searchFormControl').blur(); 
				});

				// close search form after outside click
				$(document).on('click', function(e) {
					if (!$(e.target).closest(".header-search").length) {
						$(".header-search").removeClass("act");
					}
				});

		// TEAM SLIDER
		$('.team-slider').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 300,
			slidesToScroll: 3,
			slidesToShow: 3,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				  }
				}
			]
		});

		// CAROUSEL SECTION
		var $carousel = $('.slider-for');
        var $path = $carousel.data('path');
        var prev = $path + '/assets/img/slide-prev.png';
        var next = $path + '/assets/img/slide-next.png';
        
		$carousel.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			asNavFor: '.slider-nav',
            prevArrow:'<button type="button" class="slick-prev round-bg">' + '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"45\" height=\"20\" viewBox=\"0 0 45 20\" fill=\"none\"><g clip-path=\"url(#clip0_2305_2285)\"><path d=\"M1.08325 9.99995H43.4999M1.08325 9.99995L10 18.9167M1.08325 9.99995L10 1.08325\" stroke=\"#00644A\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g><defs><clipPath id=\"clip0_2305_2285\"><rect width=\"45\" height=\"20\" fill=\"white\"/></clipPath></defs></svg></button>',
            nextArrow:'<button type="button" class="slick-next round-bg"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="20" viewBox="0 0 45 20" fill="none"><g clip-path="url(#clip0_2305_2281)">  <path d="M43.9167 9.99995H1.50012M43.9167 9.99995L35 18.9167M43.9167 9.99995L35 1.08325" stroke="#00644A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs>  <clipPath id="clip0_2305_2281">    <rect width="45" height="20" fill="white" transform="matrix(-1 0 0 1 45 0)"/>  </clipPath></defs></svg></button>'
		})

		$('.slider-nav').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.slider-for',
			dots: false,
			arrows: false,
			centerMode: false,
			focusOnSelect: true,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 4,
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 3,
				  }
				}
			]			
		});

		// GALLERY LIGHTBOX
		$('.gallery-container').each(function() {
			$(this).magnificPopup({
				delegate: 'a',
				type: 'image',
				removalDelay: 500,
				mainClass: 'mfp-with-fade',
				gallery: {
				  enabled:true
				},
				image: {
					titleSrc: 'title'
				}
			});
		});		

		// FIXED HEADER
		$(window).scroll(function() {
			var value = $(this).scrollTop();
			if (value > 80)
				$(".header-wrap").addClass("scroll");
			else
				$(".header-wrap").removeClass("scroll");
		});			
		
		// COVID POPUP
		$(".cp-close").click(function(){
  			$(".covid-popup").addClass("act");
		});
		
		// COVID POPUP
		$(".hamburger").click(function(){
  			$("body").toggleClass("nav-act");
		});		
		
		$('a[href="#footer"]').click(function(){
  			$("body").removeClass("nav-act");
		});			
			
	});
	
    $('a').each(function() {
       var a = new RegExp('/' + window.location.host + '/');
       if(!a.test(this.href)) {
           $(this).click(function(event) {
               event.preventDefault();
               event.stopPropagation();
               window.open(this.href, '_blank');
           });
       }
    });	
	
//Pagination
(function($) {
	var pagify = {
		items: {},
		container: null,
		totalPages: 1,
		perPage: 3,
		currentPage: 0,
		createNavigation: function() {
			this.totalPages = Math.ceil(this.items.length / this.perPage);

			$('.pagination', this.container.parent()).remove();
			var pagination = $('<div class="pagination"></div>').append('<a class="nav prev disabled" data-next="false"><</a>');

			for (var i = 0; i < this.totalPages; i++) {
				var pageElClass = "page";
				if (!i)
					pageElClass = "page current";
				var pageEl = '<a class="' + pageElClass + '" data-page="' + (
				i + 1) + '">' + (
				i + 1) + "</a>";
				pagination.append(pageEl);
			}
			pagination.append('<a class="nav next" data-next="true">></a>');

			this.container.after(pagination);

			var that = this;
			$("body").off("click", ".nav");
			this.navigator = $("body").on("click", ".nav", function() {
				var el = $(this);
				that.navigate(el.data("next"));
			});

			$("body").off("click", ".page");
			this.pageNavigator = $("body").on("click", ".page", function() {
				var el = $(this);
				that.goToPage(el.data("page"));
			});
		},
		navigate: function(next) {
			// default perPage to 5
			if (isNaN(next) || next === undefined) {
				next = true;
			}
			$(".pagination .nav").removeClass("disabled");
			if (next) {
				this.currentPage++;
				if (this.currentPage > (this.totalPages - 1))
					this.currentPage = (this.totalPages - 1);
				if (this.currentPage == (this.totalPages - 1))
					$(".pagination .nav.next").addClass("disabled");
				}
			else {
				this.currentPage--;
				if (this.currentPage < 0)
					this.currentPage = 0;
				if (this.currentPage == 0)
					$(".pagination .nav.prev").addClass("disabled");
				}

			this.showItems();
		},
		updateNavigation: function() {

			var pages = $(".pagination .page");
			pages.removeClass("current");
			$('.pagination .page[data-page="' + (
			this.currentPage + 1) + '"]').addClass("current");
		},
		goToPage: function(page) {

			this.currentPage = page - 1;

			$(".pagination .nav").removeClass("disabled");
			if (this.currentPage == (this.totalPages - 1))
				$(".pagination .nav.next").addClass("disabled");

			if (this.currentPage == 0)
				$(".pagination .nav.prev").addClass("disabled");
			this.showItems();
		},
		showItems: function() {
			this.items.hide();
			var base = this.perPage * this.currentPage;
			this.items.slice(base, base + this.perPage).show();

			this.updateNavigation();
		},
		init: function(container, items, perPage) {
			this.container = container;
			this.currentPage = 0;
			this.totalPages = 1;
			this.perPage = perPage;
			this.items = items;
			this.createNavigation();
			this.showItems();
		}
	};

	// stuff it all into a jQuery method!
	$.fn.pagify = function(perPage, itemSelector) {
		var el = $(this);
		var items = $(itemSelector, el);

		// default perPage to 5
		if (isNaN(perPage) || perPage === undefined) {
			perPage = 3;
		}

		// don't fire if fewer items than perPage
		if (items.length <= perPage) {
			return true;
		}

		pagify.init(el, items, perPage);
	};
})(jQuery);

$(".gallery-container").pagify(6, ".single-item");

//Pagination
(function($) {
	var pagifyteam = {
		items: {},
		container: null,
		totalPages: 1,
		perPage: 3,
		currentPage: 0,
		createNavigation: function() {
			this.totalPages = Math.ceil(this.items.length / this.perPage);

			$('.pagination', this.container.parent()).remove();
			var pagination = $('<div class="pagination d-md-none"></div>').append('<a class="nav prev disabled" data-next="false"><</a>');

			for (var i = 0; i < this.totalPages; i++) {
				var pageElClass = "page";
				if (!i)
					pageElClass = "page current";
				var pageEl = '<a class="' + pageElClass + '" data-page="' + (
				i + 1) + '">' + (
				i + 1) + "</a>";
				pagination.append(pageEl);
			}
			pagination.append('<a class="nav next" data-next="true">></a>');

			this.container.after(pagination);

			var that = this;
			$("body").off("click", ".nav");
			this.navigator = $("body").on("click", ".nav", function() {
				var el = $(this);
				that.navigate(el.data("next"));
			});

			$("body").off("click", ".page");
			this.pageNavigator = $("body").on("click", ".page", function() {
				var el = $(this);
				that.goToPage(el.data("page"));
			});
		},
		navigate: function(next) {
			// default perPage to 5
			if (isNaN(next) || next === undefined) {
				next = true;
			}
			$(".pagination .nav").removeClass("disabled");
			if (next) {
				this.currentPage++;
				if (this.currentPage > (this.totalPages - 1))
					this.currentPage = (this.totalPages - 1);
				if (this.currentPage == (this.totalPages - 1))
					$(".pagination .nav.next").addClass("disabled");
				}
			else {
				this.currentPage--;
				if (this.currentPage < 0)
					this.currentPage = 0;
				if (this.currentPage == 0)
					$(".pagination .nav.prev").addClass("disabled");
				}

			this.showItems();
		},
		updateNavigation: function() {

			var pages = $(".pagination .page");
			pages.removeClass("current");
			$('.pagination .page[data-page="' + (
			this.currentPage + 1) + '"]').addClass("current");
		},
		goToPage: function(page) {

			this.currentPage = page - 1;

			$(".pagination .nav").removeClass("disabled");
			if (this.currentPage == (this.totalPages - 1))
				$(".pagination .nav.next").addClass("disabled");

			if (this.currentPage == 0)
				$(".pagination .nav.prev").addClass("disabled");
			this.showItems();
		},
		showItems: function() {
			this.items.hide();
			var base = this.perPage * this.currentPage;
			this.items.slice(base, base + this.perPage).show();

			this.updateNavigation();
		},
		init: function(container, items, perPage) {
			this.container = container;
			this.currentPage = 0;
			this.totalPages = 1;
			this.perPage = perPage;
			this.items = items;
			this.createNavigation();
			this.showItems();
		}
	};

	// stuff it all into a jQuery method!
	$.fn.pagifyteam = function(perPage, itemSelector) {
		var el = $(this);
		var items = $(itemSelector, el);

		// default perPage to 5
		if (isNaN(perPage) || perPage === undefined) {
			perPage = 3;
		}

		// don't fire if fewer items than perPage
		if (items.length <= perPage) {
			return true;
		}

		pagifyteam.init(el, items, perPage);
	};
})(jQuery);

$(".team-container").pagifyteam(4, ".single-team");

}(jQuery));